<div class="position-relative">
  <div
    [ngClass]="{ 'filter-overlay': showFilterPanel }"
    (click)="changeShowFilterPanel.emit()"
    [attr.aria-hidden]="true"
    (keyup)="(null)"
  ></div>
  <aside
    class="customizer"
    [ngClass]="{ 'show-service-panel': showFilterPanel }"
  >
    <ng-scrollbar class="filter-container">
      <div class="filter-header">
        <div
          class="close-filter"
          (click)="changeShowFilterPanel.emit()"
          (keyup)="(null)"
          [attr.aria-hidden]="true"
        >
          <i class="material-symbols-rounded">close</i>
        </div>
        <h5 class="m-0 font-weight-bolder" style="color: #123044">
          Filtrar por
        </h5>
      </div>
      <hr class="m-0" />
      <div class="filter-body p-4">
        <form autocomplete="off">
          <ng-content></ng-content>
        </form>
        <hr />
      </div>
    </ng-scrollbar>
  </aside>
</div>
<!-- <div class="position-relative">
  <div
    [ngClass]="{ 'filter-overlay': showFilterPanel }"
    (click)="changeShowFilterPanel.emit()"
    [attr.aria-hidden]="true"
    (keyup)="(null)"></div>
  <aside class="customizer" [ngClass]="{ 'show-service-panel': showFilterPanel }">
    <ng-scrollbar class="c-filter">
      <div class="c-filter-header">
        <label class="c-text-filtro">Filtros</label>
        <div class="c-filter-cerrar" (click)="changeShowFilterPanel.emit()" (keyup)="(null)" [attr.aria-hidden]="true">
          <i class="material-symbols-rounded">close</i>
        </div>
      </div>
      <hr class="m-0" />
      <div class="filter-body p-4">
        <form autocomplete="off">
          <ng-content></ng-content>
        </form>
        <hr />
      </div>
    </ng-scrollbar>
  </aside>
</div>
 -->
